export const coreAddresses = {
  balanceTracker: "0xB9E491A3BB9d4B155d31a9cA6B9dE245CA16AAe6",
  eVaultFactory: "0x84711986Fd3BF0bFe4a8e6d7f4E22E67f7f27F04",
  eVaultImplementation: "0x58270C41552Bb2bef3Dc4e103b6f0c226032f007",
  eulerEarnFactory: "0x377879A039343FEc7564e54616e519328951DA6D",
  evc: "0xd8CeCEe9A04eA3d941a959F68fb4486f23271d09",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0x91868601df03ED8E134EaAaB5E06F7183CC8383f",
  sequenceRegistry: "0xcB1bB0A8A7ddeb09983dC1e7F880DCEdc39362BA",
} as const
